import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  FuelType,
  FuelTypeValues,
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesGenerator,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionGeneratorDto } from './dto.type';

export class QuestionGeneratorMapper {
  static dtoToEntity(
    dto: QuestionGeneratorDto,
  ): ImpactCo2Answer<ValuesGenerator> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'GENERATOR',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        fuelType: validateValueInType<FuelType>(dto.fuelType, FuelTypeValues),
        fuelConsumption: parseFloat(dto.fuelConsumption.toString()),
        hasGenerator: dto.hasGenerator,
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesGenerator>,
    projectId: number,
  ): Omit<QuestionGeneratorDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      fuelType: answer.values.fuelType,
      fuelConsumption: answer.values.fuelConsumption,
      hasGenerator: answer.values.hasGenerator,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
